import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=d6bcab58&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=d6bcab58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bcab58",
  null
  
)

export default component.exports